import type { Notifier } from "../NotificationScheduler.js";

/** A small colored-circle icon as a data URL, so the task's color shows in the
 *  notification. The Web Notifications API has no accent-color field, but it
 *  does render an `icon`. */
function colorIcon(hex: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><circle cx="32" cy="32" r="28" fill="${hex}"/></svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

/**
 * Browser adapter: uses the Notifications API. Fires only while the tab is open;
 * real background firing needs a service worker (Phase 2 / step F5).
 */
export const webNotifier: Notifier = {
  async send({ title, body, color }) {
    if (typeof Notification === "undefined") return;
    if (Notification.permission !== "granted") {
      const p = await Notification.requestPermission();
      if (p !== "granted") return;
    }
    const options: NotificationOptions = color ? { body, icon: colorIcon(color) } : { body };
    new Notification(title, options);
  },

  async sendTest({ atMs }) {
    if (typeof Notification === "undefined") throw new Error("This browser doesn't support notifications.");
    if (Notification.permission !== "granted") {
      const p = await Notification.requestPermission();
      if (p !== "granted") throw new Error("Notification permission was denied.");
    }
    const fire = () => new Notification("Test notification", {
      body: atMs ? "Scheduled test fired." : "Immediate test — notifications are working.",
    });
    // No service worker yet, so a delayed test relies on the tab staying open.
    if (atMs) setTimeout(fire, Math.max(0, atMs - Date.now()));
    else fire();
    return { background: false };
  },
};
